var _style, _defs, _path, _path2, _path3, _defs2, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000130640216564974327740000017219345721332747672_);}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st3{mask:url(#mask1_1733_444_00000173119005683856377750000008768523949192061587_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.4,
    y: 6.4,
    width: 90.3,
    height: 90.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075142547196907975080000005165666712029929638_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075142547196907975080000005165666712029929638_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,31.2l4.4,1.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,65.6v-5.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,65.6v-5.3"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 7,
    y: 10.7,
    width: 89,
    height: 81.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10.7,
    width: 89,
    height: 81.6,
    id: "mask1_1733_444_00000173119005683856377750000008768523949192061587_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.4,6.4h90.3v90.3H6.4V6.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.1,53.3C22,60.8,16.7,66.9,9.4,69L9,69.1c2.3-4.6,3.5-9.8,3.5-14.9V54c0-7.2,5.8-13,13-13 c5.5,0,10.7,0,10.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,51.5h19.4V40.9H39.3V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,40.9h-3.9c-6.8,0-12.3,5.5-12.3,12.3v14.1l-3.5,7.1v12.3c0,1.9,1.6,3.5,3.5,3.5h8.8v-1.3 c0-2.4-1.4-4.6-3.5-5.7l1.8-8.8c3.3-1.1,5.8-3.8,6.6-7.2l0.4-1.6c7.3,3.4,16,3.4,23.3,0v21.2c0,1.9,1.6,3.5,3.5,3.5h8.8v-1.3 c0-2.4-1.4-4.6-3.5-5.7l1.8-15.9c5.5-3.3,8.8-9.2,8.8-15.6V33l5.7,5.7c1.2,1.2,3.2,1.4,4.6,0.3l2.4-1.8c1.3-1,1.8-2.7,1.1-4.2 l-5.9-13.3l4.5-7.1H80.8c-8.8,0-15.9,7.1-15.9,15.9v7.1c0,2.9-2.4,5.3-5.3,5.3h-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,70.9V51.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquine);
export default __webpack_public_path__ + "static/media/Equine.33a8a05dc950ee24950e96b43051f2c9.svg";
export { ForwardRef as ReactComponent };